module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/076-suriname-25f74b11c593fab7be1a59547735cc67.svg";